import { useSelector } from "react-redux";
import CryptoJS from "crypto-js";
import PASB_HollowShaft from "../../../Cartesian/Assets/PASB/PAS4xBxxxxxxxxxxxxxH-XXXXXXX.png";
import PASB_Left_OnlyMotor from "../../../Cartesian/Assets/PASB/PAS4xBxxxxxxxxxxxxxL-1XXXxxx.png";
import PASB_Left_MotorGearboxProductAngular from "../../../Cartesian/Assets/PASB/PAS4xBxxxxxxxxxxxxxL-2xAxxxx.png";
import PASB_Left_MotorGearboxProductStraight from "../../../Cartesian/Assets/PASB/PAS4xBxxxxxxxxxxxxxL-2xGxxxx.png";
import PASB_Left_GearboxOnlyProductAngular from "../../../Cartesian/Assets/PASB/PAS4xBxxxxxxxxxxxxxL-3xAxXXX.png";
import PASB_Left_GearboxOnlyProductStraight from "../../../Cartesian/Assets/PASB/PAS4xBxxxxxxxxxxxxxL-3xGxXXX.png";
import PASB_Left_AdaptationKitOnly from "../../../Cartesian/Assets/PASB/PAS4xBxxxxxxxxxxxxxL-4XXXxxx.png";

import PASB_Right_OnlyMotor from "../../../Cartesian/Assets/PASB/PAS4xBxxxxxxxxxxxxxR-1XXXxxx.png";
import PASB_Right_MotorGearboxProductAngular from "../../../Cartesian/Assets/PASB/PAS4xBxxxxxxxxxxxxxR-2xAxxxx.png";
import PASB_Right_MotorGearboxProductStraight from "../../../Cartesian/Assets/PASB/PAS4xBxxxxxxxxxxxxxR-2xGxxxx.png";
import PASB_Right_GearboxOnlyProductAngular from "../../../Cartesian/Assets/PASB/PAS4xBxxxxxxxxxxxxxR-3xAxXXX.png";
import PASB_Right_GearboxOnlyProductStraight from "../../../Cartesian/Assets/PASB/PAS4xBxxxxxxxxxxxxxR-3xGxXXX.png";
import PASB_Right_AdaptationKitOnly from "../../../Cartesian/Assets/PASB/PAS4xBxxxxxxxxxxxxxR-4XXXxxx.png";

import PAD42B_Left_OnlyMotor from "../../../Cartesian/Assets/PAD4/PAD42xBxxxxxxxxxxxxL-1XXXxxx.png";
import PAD42B_Left_MotorGearboxProductAngular from "../../../Cartesian/Assets/PAD4/PAD42xBxxxxxxxxxxxxL-2xAxxxx.png";
import PAD42B_Left_MotorGearboxProductStraight from "../../../Cartesian/Assets/PAD4/PAD42xBxxxxxxxxxxxxL-2xGxxxx.png";
import PAD42B_Left_GearboxOnlyProductAngular from "../../../Cartesian/Assets/PAD4/PAD42xBxxxxxxxxxxxxL-3xAxXXX.png";
import PAD42B_Left_GearboxOnlyProductStraight from "../../../Cartesian/Assets/PAD4/PAD42xBxxxxxxxxxxxxL-3xGxXXX.png";
import PAD42B_Left_AdaptationKitOnly from "../../../Cartesian/Assets/PAD4/PAD42xBxxxxxxxxxxxxL-4XXXxxx.png";
//TODO import PAD42B_Left_HollowShaft from "../../../Cartesian/Assets/PAD4PAD42xBxxxxxxxxxxxxL-XXXXXXX.png";

import PAD42B_Right_OnlyMotor from "../../../Cartesian/Assets/PAD4/PAD42xBxxxxxxxxxxxxR-1XXXxxx.png";
import PAD42B_Right_MotorGearboxProductAngular from "../../../Cartesian/Assets/PAD4/PAD42xBxxxxxxxxxxxxR-2xAxxxx.png";
import PAD42B_Right_MotorGearboxProductStraight from "../../../Cartesian/Assets/PAD4/PAD42xBxxxxxxxxxxxxR-2xGxxxx.png";
import PAD42B_Right_GearboxOnlyProductAngular from "../../../Cartesian/Assets/PAD4/PAD42xBxxxxxxxxxxxxR-3xAxXXX.png";
import PAD42B_Right_GearboxOnlyProductStraight from "../../../Cartesian/Assets/PAD4/PAD42xBxxxxxxxxxxxxR-3xGxXXX.png";
import PAD42B_Right_AdaptationKitOnly from "../../../Cartesian/Assets/PAD4/PAD42xBxxxxxxxxxxxxR-4XXXxxx.png";
// TODO import PAD42B_Right_HollowShaft from "../../../Cartesian/Assets/PAD42xBxxxxxxxxxxxxR-XXXXXXX.png";

/* TODO
PAD42EBxxxxxxxxxxxxH-XXXXXXX.png
PAD42EBxxxxxxxxxxxxT-1XXXxxx.png
PAD42EBxxxxxxxxxxxxT-2xAxxxx.png
PAD42EBxxxxxxxxxxxxT-2xGxxxx.png
PAD42EBxxxxxxxxxxxxT-3xAxXXX.png
PAD42EBxxxxxxxxxxxxT-3xGxXXX.png
PAD42EBxxxxxxxxxxxxT-4XXXxxx.png
*/

/* TODO
PAS4xSxxxxxxxxxD-XXXXXXX.png
PAS4xSxxxxxxxxxS-1XXXxxx.png
PAS4xSxxxxxxxxxS-2xAxxxx.png
PAS4xSxxxxxxxxxS-2xGxxxx.png
PAS4xSxxxxxxxxxS-3xAxXXX.png
PAS4xSxxxxxxxxxS-3xGxXXX.png
PAS4xSxxxxxxxxxS-4XXXxxx.png
*/

import rightMountingImage from "../../../Cartesian/Assets/right-mounting.png";
import t from "../../../Common/utils/translation/translator";
import { selectAxisOptions, selectSelectedAxis, selectSelectedBundle } from "../slices/cartesian";

const FORCE_MAX = 5000;
const FORCE_MIN = -5000;
const FORCE_MIN_POSITIVE = 0;
const DISTANCE_MAX = 9999;
const DISTANCE_MIN = -9999;
const DISTANCE_MIN_POSITIVE = 0;

export function getForceMax() {
  return FORCE_MAX;
}

export function getForceMin() {
  return FORCE_MIN;
}

export function getForceMinPositive() {
  return FORCE_MIN_POSITIVE;
}

export function getDistanceMax() {
  return DISTANCE_MAX;
}

export function getDistanceMin() {
  return DISTANCE_MIN;
}

export function getDistanceMinPositive() {
  return DISTANCE_MIN_POSITIVE;
}

export const KINEMATICS_OPTIONS = {
  linear: t("cartesian.ui.kinematics.linear"),
  cantilever: t("cartesian.ui.kinematics.cantilever")
};

export const CARRIAGE_ORIENTATIONS = {
  top: "TOP",
  upSideDown: "UP_SIDE_DOWN",
  onTheSide: "ON_THE_SIDE"
};

export function getMaxOrientationAngle(orientation) {
  switch (orientation) {
    case CARRIAGE_ORIENTATIONS.top:
      return 90;
    case CARRIAGE_ORIENTATIONS.upSideDown:
      return 180;
    case CARRIAGE_ORIENTATIONS.onTheSide:
      return 180;
    default:
      return 90;
  }
}

export function getMinOrientationAngle(orientation) {
  switch (orientation) {
    case CARRIAGE_ORIENTATIONS.top:
      return 0;
    case CARRIAGE_ORIENTATIONS.upSideDown:
      return 91;
    case CARRIAGE_ORIENTATIONS.onTheSide:
      return 0;
    default:
      return 0;
  }
}

export function getDriveQuantity(bom) {
  const driveProduct = bom.find((item) => item.productType === "Drive");
  return driveProduct ? driveProduct.quantity : 0;
}

export function getAdaptationKitWithinBundleQty(bom) {
  const adaptationKitWithinBundle = bom.find((item) => item.productType === "Adaptation kit");
  return adaptationKitWithinBundle ? adaptationKitWithinBundle.quantity : 0;
}

export function getAdaptationKitToBundleQty(bom) {
  const adaptationKitToBundle = bom.find((item) => item.productType === "Adaptation material axis to Bundle");
  return adaptationKitToBundle ? adaptationKitToBundle.quantity : 0;
}

export function getAxisQty(bom) {
  const axis = bom.find((item) => item.productType === "Axis");
  return axis ? axis.quantity : 0;
}

export function orientationToDisplayString(orientation) {
  switch (orientation) {
    case CARRIAGE_ORIENTATIONS.top:
      return t("cartesian.ui.mechanics.carriage_orientation_top");
    case CARRIAGE_ORIENTATIONS.upSideDown:
      return t("cartesian.ui.mechanics.carriage_orientation_upSideDown");
    case CARRIAGE_ORIENTATIONS.onTheSide:
      return t("cartesian.ui.mechanics.carriage_orientation_side");
    default:
      return "Top";
  }
}

export const AXIS_SUPPORTS = {
  fullyOrDistributed: "FULLY_OR_DISTRIBUTED",
  end: "END"
};

export function axisSupportToDisplayString(orientation) {
  switch (orientation) {
    case "FULLY_OR_DISTRIBUTED":
      return t("cartesian.ui.mechanics.axis_support_fully_distributed_short");
    case "END":
      return t("cartesian.ui.mechanics.axis_support_end");
    default:
      return t("cartesian.ui.mechanics.axis_support_fully_distributed_short");
  }
}

export const MOVEMENT_TYPES = {
  trapezoidal: t("cartesian.ui.dynamics.movement.trapezoidal"),
  // dwell: "DWELL",
  triangular: t("cartesian.ui.dynamics.movement.triangular")
};

export const DIRECTIONS = {
  forward: t("cartesian.ui.dynamics.direction.forward"),
  // stop: "STOP",
  backward: t("cartesian.ui.dynamics.direction.backward")
};

const createHash = (fields) => {
  const concatenatedFields = fields.join("");
  return CryptoJS.SHA256(concatenatedFields).toString(CryptoJS.enc.Hex);
};

const getLoadParameterString = (loadParameter) => {
  return loadParameter.title + loadParameter.payload + loadParameter.dx + loadParameter.dy + loadParameter.dz;
};

const getLoadParametersString = (loadParameters) => {
  return loadParameters.map((loadParameter) => getLoadParameterString(loadParameter)).join("");
};

const getForceParameterString = (forceParameter) => {
  return (
    forceParameter.title +
    forceParameter.fx +
    forceParameter.fy +
    forceParameter.fz +
    forceParameter.dx +
    forceParameter.dy +
    forceParameter.dz
  );
};

const getForceParametersString = (forceParameters) => {
  return forceParameters.map((forceParameter) => getForceParameterString(forceParameter)).join("");
};

const getDefaultCarriageOrientation = () => {
  return CARRIAGE_ORIENTATIONS.top;
};

const getDefaultStrokeLength = () => {
  return "1000";
};

const getDefaultAxisAngle = () => {
  return "0";
};

const getDefaultQuantityCarriages = () => {
  return 1;
};

const getDefaultDistanceBetweenCarriages = () => {
  return "35";
};

const getDefaultCarriageConnected = () => {
  return false;
};

const getDefaultLoadsParameters = () => {
  return [
    {
      id: new Date().getTime(),
      enable: true,
      title: t("cartesian.ui.mechanics.load_parameters.load") + " 1",
      payload: "1",
      dx: "0",
      dy: "0",
      dz: "100"
    }
  ];
};

const getDefaultForcesParameters = () => {
  return [];
};

const getDefaultMechanicsHash = () => {
  const selectedFields = [
    getDefaultCarriageOrientation(),
    getDefaultStrokeLength(),
    getDefaultAxisAngle(),
    getDefaultQuantityCarriages().toString(),
    getDefaultDistanceBetweenCarriages(),
    getDefaultCarriageConnected().toString(),
    getLoadParametersString(getDefaultLoadsParameters()),
    getForceParametersString(getDefaultForcesParameters())
  ];
  return createHash(selectedFields);
};

export const getMechanicsHash = (mechanics) => {
  const selectedFields = [
    mechanics.carriageOrientation,
    mechanics.strokeLength,
    mechanics.axisAngle,
    mechanics.quantityCarriages.toString(),
    mechanics.distanceBetweenCarriages,
    mechanics.carriageConnected ? mechanics.carriageConnected.toString() : "false",
    getLoadParametersString(mechanics.loadsParameters),
    getForceParametersString(mechanics.forcesParameters)
  ];
  return createHash(selectedFields);
};

export const DEFAULT_KINEMATICS = {
  kinematicsType: undefined
};

export const DEFAULT_MECHANICS = {
  carriageOrientation: getDefaultCarriageOrientation(),
  strokeLength: getDefaultStrokeLength(),
  axisAngle: getDefaultAxisAngle(),
  doubleAxisDistance: "",
  doubleAxisChoice: "",
  axisSupport: AXIS_SUPPORTS.fullyOrDistributed,
  isTransverseAcceleration: false,
  transverseAcceleration: "0.1",
  quantityCarriages: getDefaultQuantityCarriages(),
  carriagePosition: "center",
  distanceBetweenCarriages: getDefaultDistanceBetweenCarriages(),
  carriageConnected: getDefaultCarriageConnected(),
  loadsParameters: getDefaultLoadsParameters(),
  forcesParameters: getDefaultForcesParameters(),
  focusText: "",
  selectedField: "",
  selectedIndex: -1,
  hash: getDefaultMechanicsHash()
};

// will be updated when we will have the values of the min and max of some filters
export const DEFAULT_CARTESIAN_FILTERS = {
  applicationDataFilter: {
    withCoverstrip: false,
    withDrivenAxis: true
  },

  axisFilter: {
    driveType: null,
    profileDimension: null,
    axisType: ["PAD4 axis with two toothed belt", "PAS4 axis with toothed belt", "PAS4 axis with ball screw"],
    functionAvailable: ["driven axis"]
  },
  guideFilter: {
    guideType: null,
    functionAvailable: [null, "standard"]
  },
  mechanicalDriveFilter: {
    functionAvailable: [null, "standard"]
  }
};

export const DEFAULT_AXIS_SELECTION = {
  axesCombinations: null,
  selectedAxis: null,
  selectedFilters: DEFAULT_CARTESIAN_FILTERS
};

export const DEFAULT_AXIS_OPTIONS = {
  selectedBundle: null,
  bundleChanged: false,
  sensor: 2,
  pnpSensor: true,
  sensorConnected: false,
  mountingOptions: {
    gearbox: {
      orientation: "",
      mountingSide: "",
      mounted: false
    },
    motor: {
      orientation: "",
      mountingSide: "",
      mounted: false
    },
    drive: {
      addedToBOM: true
    }
  }
};

const getCarriageForcesString = (carriage) => {
  if (!carriage || !carriage.forces || !Array.isArray(carriage.forces)) {
    return ""; // Return an empty string if the load is not valid
  }
  return carriage.forces.join(""); // Concatenate the items in the load array
};

const getCarriageLoadsString = (carriage) => {
  if (!carriage || !carriage.loads || !Array.isArray(carriage.loads)) {
    return ""; // Return an empty string if the load is not valid
  }
  return carriage.loads.join(""); // Concatenate the items in the load array
};

const getCarriageString = (carriage) => {
  return getCarriageLoadsString(carriage) + getCarriageForcesString(carriage);
};

const getCarriagesString = (carriages) => {
  return carriages.map((carriage) => getCarriageString(carriage)).join("");
};

const getStepString = (step) => {
  return (
    step.stepName +
    step.movementType +
    step.movement +
    step.direction +
    step.dwellTime +
    step.travelTime +
    step.tacc +
    step.sameTaccAndTdec +
    step.tdec +
    step.peak +
    step.aacc +
    step.sameAaccAndAdcc +
    step.adcc +
    getCarriagesString(step.carriages)
  );
};

const getStepsString = (steps) => {
  return steps.map((step) => getStepString(step)).join("");
};

const getCycleRunningString = (cycleRunning) => {
  return cycleRunning.numberOfCyclePerHour + cycleRunning.workingHoursPerDay + cycleRunning.workingDaysPerYear;
};

export const getDynamicsHash = (dynamics) => {
  const selectedFields = [
    dynamics.startPosition,
    getStepsString(dynamics.steps),
    getCycleRunningString(dynamics.cycleRunning)
  ];
  const dynamicHash = createHash(selectedFields);
  return dynamicHash;
};

const getDefaultStartPosition = () => {
  return "0";
};

const getDefaultNumberOfCyclePerHour = () => {
  return "";
};

const getDefaultWorkingHoursPerDay = () => {
  return 8;
};

const getDefaultWorkingDaysPerYear = () => {
  return 220;
};

export const getDefaultDynamicsHash = (dynamics) => {
  const selectedFields = [
    getDefaultStartPosition(),
    getStepsString(getDefaultSteps()),
    getCycleRunningString(getDefaultCycleRunning())
  ];
  const defaultDynmaicHash = createHash(selectedFields);
  return defaultDynmaicHash;
};

const getDefaultSteps = () => {
  return [];
};

const getDefaultCycleRunning = () => {
  return {
    numberOfCyclePerHour: getDefaultNumberOfCyclePerHour(),
    workingHoursPerDay: getDefaultWorkingHoursPerDay(),
    workingDaysPerYear: getDefaultWorkingDaysPerYear()
  };
};

export const DEFAULT_DYNAMICS = {
  startPosition: getDefaultStartPosition(),
  steps: getDefaultSteps(),
  cycleRunning: getDefaultCycleRunning(),
  hash: getDefaultDynamicsHash()
};

export const TESTING_DYNAMICS_DATA = {
  startPosition: 200,
  steps: [
    {
      stepName: t("cartesian.ui.dynamics.step") + " 1",
      movementType: MOVEMENT_TYPES.trapezoidal,
      movement: 500,
      direction: DIRECTIONS.forward,
      dwellTime: 300,
      travelTime: 1000,
      tacc: 95,
      sameTaccAndTdec: true,
      tdec: 95,
      peak: undefined,
      aacc: undefined,
      sameAaccAndAdcc: false,
      adcc: undefined,
      carriages: []
    },
    {
      stepName: t("cartesian.ui.dynamics.step") + " 2",
      movementType: MOVEMENT_TYPES.trapezoidal,
      movement: 600,
      direction: DIRECTIONS.backward,
      dwellTime: 100,
      travelTime: 1000,
      tacc: 95,
      sameTaccAndTdec: false,
      tdec: 100,
      peak: null,
      aacc: null,
      sameAaccAndAdcc: false,
      adcc: null,
      carriages: []
    }
  ],
  cycleRunning: {
    numberOfCyclePerHour: 10,
    workingHoursPerDay: 9,
    workingDaysPerYear: 200
  },
  isValid: true
};

// Regular expressions for product codes
const PAS4B = new RegExp("^GCR_PAS4.*B");
const PAS4P = new RegExp("^GCR_PAS4.*P");
const PAS4H = new RegExp("^GCR_PAS4.*H");
const PAS4S = new RegExp("^GCR_PAS4.*S");
const PAS4A = new RegExp("^GCR_PAS4.*A");
const PAD42B = new RegExp("^GCR_PAD42B");
const PAD42E = new RegExp("^GCR_PAD42E");
const PAD42P = new RegExp("^GCR_PAD42P");

// Mounting options
const RIGHT = "Right";
const LEFT = "Left";
export const HOLLOW_SHAFT = "Hollow shaft at both ends";
const ON_BOTH_SIDE = "On both sides at one end";
const SUPPORT_AXIS = "Support axis";
const STRAIGHT_MOUNTED = "Straight mounted";
const WITH_SHAFT = "With shaft";

// Motor and gearbox orientation
export const NO_MOTOR = t("cartesian.ui.axis_options.mounting_no_motor");
export const NO_GEARBOX = t("cartesian.ui.axis_options.mounting_no_gearbox");

export function isPAD42BOrPAD42P() {
  const selectedAxis = useSelector(selectSelectedAxis);
  const productCode = selectedAxis?.axis?.axisGCR;
  return PAD42B.test(productCode) || PAD42P.test(productCode) ? true : false;
}

function getPASBMountingLeftImage(motor, gearBox, adaptationKit) {
  // console.log("getPASBMountingLeftImage");
  if (motor && !gearBox) {
    return PASB_Left_OnlyMotor;
  }

  if (motor && gearBox) {
    return gearBox.productOrComponentType === "PLANETARY_GEARBOX"
      ? PASB_Left_MotorGearboxProductStraight
      : PASB_Left_MotorGearboxProductAngular;
  }

  if (!motor && gearBox) {
    return gearBox.productOrComponentType === "PLANETARY_GEARBOX"
      ? PASB_Left_GearboxOnlyProductStraight
      : PASB_Left_GearboxOnlyProductAngular;
  }

  if (!motor && !gearBox && adaptationKit) {
    return PASB_Left_AdaptationKitOnly;
  }
}

function getPAD42BMountingLeftImage(motor, gearBox, adaptationKit) {
  // console.log("getPAD42BMountingLeftImage");
  if (motor && !gearBox) {
    return PAD42B_Left_OnlyMotor;
  }

  if (motor && gearBox) {
    return gearBox.productOrComponentType === "PLANETARY_GEARBOX"
      ? PAD42B_Left_MotorGearboxProductStraight
      : PAD42B_Left_MotorGearboxProductAngular;
  }

  if (!motor && gearBox) {
    return gearBox.productOrComponentType === "PLANETARY_GEARBOX"
      ? PAD42B_Left_GearboxOnlyProductStraight
      : PAD42B_Left_GearboxOnlyProductAngular;
  }

  if (!motor && !gearBox && adaptationKit) {
    return PAD42B_Left_AdaptationKitOnly;
  }
}

function getPASBMountingRightImage(motor, gearBox, adaptationKit) {
  // console.log("getPASBMountingRightImage");
  if (motor && !gearBox) {
    return PASB_Right_OnlyMotor;
  }

  if (motor && gearBox) {
    return gearBox.productOrComponentType === "PLANETARY_GEARBOX"
      ? PASB_Right_MotorGearboxProductStraight
      : PASB_Right_MotorGearboxProductAngular;
  }

  if (!motor && gearBox) {
    return gearBox.productOrComponentType === "PLANETARY_GEARBOX"
      ? PASB_Right_GearboxOnlyProductStraight
      : PASB_Right_GearboxOnlyProductAngular;
  }

  if (!motor && !gearBox && adaptationKit) {
    return PASB_Right_AdaptationKitOnly;
  }
}

function getPAD42BMountingRightImage(motor, gearBox, adaptationKit) {
  // console.log("getPAD42BMountingRightImage", motor, gearBox, adaptationKit);
  if (motor && !gearBox) {
    return PAD42B_Right_OnlyMotor;
  }

  if (motor && gearBox) {
    return gearBox.productOrComponentType === "PLANETARY_GEARBOX"
      ? PAD42B_Right_MotorGearboxProductStraight
      : PAD42B_Right_MotorGearboxProductAngular;
  }

  if (!motor && gearBox) {
    return gearBox.productOrComponentType === "PLANETARY_GEARBOX"
      ? PAD42B_Right_GearboxOnlyProductStraight
      : PAD42B_Right_GearboxOnlyProductAngular;
  }

  if (!motor && !gearBox && adaptationKit) {
    return PAD42B_Right_AdaptationKitOnly;
  }
}

function getPASBMountingImage(mountingSide, motor, gearBox, adaptationKit) {
  // console.log("getPASBMountingImage", motor, gearBox, adaptationKit);
  if (mountingSide === HOLLOW_SHAFT) {
    return PASB_HollowShaft;
  }

  if (mountingSide?.toLowerCase() === LEFT.toLowerCase()) {
    return getPASBMountingLeftImage(motor, gearBox, adaptationKit);
  }

  if (mountingSide?.toLowerCase() === RIGHT.toLowerCase()) {
    return getPASBMountingRightImage(motor, gearBox, adaptationKit);
  }
}

function getPAD42BMountingImage(mountingSide, motor, gearBox, adaptationKit) {
  if (mountingSide?.toLowerCase() === LEFT.toLowerCase()) {
    return getPAD42BMountingLeftImage(motor, gearBox, adaptationKit);
  }

  if (mountingSide?.toLowerCase() === RIGHT.toLowerCase()) {
    return getPAD42BMountingRightImage(motor, gearBox, adaptationKit);
  }
}

export function getMountingImage(selectedMountingSide) {
  // console.log("getMountingImage", selectedMountingSide);
  const axisOptions = useSelector(selectAxisOptions);
  const motor = axisOptions?.selectedBundle?.bundleData?.motor;
  const gearBox = axisOptions?.selectedBundle?.bundleData?.gearbox;
  const adaptationKit = axisOptions?.selectedBundle?.bundleData?.adaptationKit;
  const selectedAxis = useSelector(selectSelectedAxis);
  const axisGCR = selectedAxis?.axis?.axisGCR;

  if (PAS4B.test(axisGCR)) {
    return getPASBMountingImage(selectedMountingSide, motor, gearBox, adaptationKit);
  }

  if (PAD42B.test(axisGCR)) {
    return getPAD42BMountingImage(selectedMountingSide, motor, gearBox, adaptationKit);
  }

  return rightMountingImage;
}

export function isSelectBundleDisabled(productCode) {
  // console.log("isSelectBundleDisabled", productCode);
  if (PAS4H.test(productCode) || PAS4A.test(productCode)) {
    return true;
  }
  return false;
}

export function getMountingOptionsSideDefault() {
  // console.log("getMountingOptionsSideDefault");
  const selectedBundle = useSelector(selectSelectedBundle);
  const selectedAxis = useSelector(selectSelectedAxis);
  const axisOptions = useSelector(selectAxisOptions);
  const productCode = selectedAxis?.axis?.axisGCR;
  let motorMounted = axisOptions?.mountingOptions?.motor?.mounted;
  motorMounted = motorMounted === undefined ? false : motorMounted;
  let gearboxMounted = axisOptions?.mountingOptions?.gearbox?.mounted;
  gearboxMounted = gearboxMounted === undefined ? false : gearboxMounted;
  const motor = axisOptions?.selectedBundle?.bundleData?.motor;
  const gearBox = axisOptions?.selectedBundle?.bundleData?.gearbox;

  if (PAS4B.test(productCode) || PAS4P.test(productCode)) {
    return (motorMounted && motor) || (gearboxMounted && gearBox) ? [RIGHT, LEFT] : [HOLLOW_SHAFT];
  }
  if (PAS4H.test(productCode) || PAS4A.test(productCode)) {
    return [SUPPORT_AXIS];
  }
  if (PAS4S.test(productCode)) {
    return (motorMounted && motor) || (gearboxMounted && gearBox) ? [STRAIGHT_MOUNTED] : [WITH_SHAFT];
  }
  if (PAD42B.test(productCode) || PAD42P.test(productCode)) {
    if (selectedBundle) {
      return (motorMounted && motor) || (gearboxMounted && gearBox) ? [RIGHT, LEFT] : [HOLLOW_SHAFT];
    } else {
      return [RIGHT, LEFT];
    }
  }
  if (PAD42E.test(productCode)) {
    return (motorMounted && motor) || (gearboxMounted && gearBox) ? [RIGHT, LEFT, ON_BOTH_SIDE] : [HOLLOW_SHAFT];
  }
  return [];
}

export function getMotorDiabledOptions() {
  // console.log("getMotorDiabledOptions");
  const selectedAxis = useSelector(selectSelectedAxis);
  const axisOptions = useSelector(selectAxisOptions);
  const productCode = selectedAxis?.axis?.axisGCR;
  let motorMounted = axisOptions?.mountingOptions?.motor?.mounted;
  motorMounted = motorMounted === undefined ? false : motorMounted;
  const motor = axisOptions?.selectedBundle?.bundleData?.motor;
  if (
    PAS4B.test(productCode) ||
    PAS4P.test(productCode) ||
    PAS4S.test(productCode) ||
    PAD42B.test(productCode) ||
    PAD42P.test(productCode) ||
    PAD42E.test(productCode)
  ) {
    return motorMounted && motor ? [NO_MOTOR] : ["0", "90", "180", "270"];
  }
  return [];
}

export function getGearBoxDiabledOptions() {
  // console.log("getGearBoxDiabledOptions");
  const selectedAxis = useSelector(selectSelectedAxis);
  const axisOptions = useSelector(selectAxisOptions);
  const productCode = selectedAxis?.axis?.axisGCR;
  let gearboxMounted = axisOptions?.mountingOptions?.gearbox?.mounted;
  gearboxMounted = gearboxMounted === undefined ? false : gearboxMounted;
  const gearBox = axisOptions?.selectedBundle?.bundleData?.gearbox;
  if (
    PAS4B.test(productCode) ||
    PAS4P.test(productCode) ||
    PAS4S.test(productCode) ||
    PAD42B.test(productCode) ||
    PAD42P.test(productCode) ||
    PAD42E.test(productCode)
  ) {
    return gearboxMounted && gearBox ? [NO_GEARBOX] : ["0", "90", "180", "270"];
  }
  return [];
}

export function getMotorOrientation() {
  // console.log("getMotorOrientation");
  const selectedAxis = useSelector(selectSelectedAxis);
  const productCode = selectedAxis?.axis?.axisGCR;
  if (PAS4H.test(productCode) || PAS4A.test(productCode)) {
    return [NO_MOTOR];
  }
  return ["0", "90", "180", "270", NO_MOTOR];
}

export function getMountingOptions(productCode, isMotor, isGearBox, isMotorMounted, isGearBoxMounted) {
  // console.log("getMountingOptions", productCode, isMotor, isGearBox, isMotorMounted, isGearBoxMounted);
  if (PAS4B.test(productCode) || PAS4P.test(productCode)) {
    return (isMotorMounted && isMotor) || (isGearBoxMounted && isGearBox) ? [RIGHT, LEFT] : [HOLLOW_SHAFT];
  }
  if (PAS4H.test(productCode) || PAS4A.test(productCode)) {
    return [SUPPORT_AXIS];
  }
  if (PAS4S.test(productCode)) {
    return (isMotorMounted && isMotor) || (isGearBoxMounted && isGearBox) ? [STRAIGHT_MOUNTED] : [WITH_SHAFT];
  }

  if (PAD42B.test(productCode) || PAD42P.test(productCode)) {
    return (isMotorMounted && isMotor) || (isGearBoxMounted && isGearBox) ? [RIGHT, LEFT] : [HOLLOW_SHAFT];
  }
  if (PAD42E.test(productCode)) {
    return (isMotorMounted && isMotor) || (isGearBoxMounted && isGearBox)
      ? [RIGHT, LEFT, ON_BOTH_SIDE]
      : [HOLLOW_SHAFT];
  }
  return [];
}

export function getDefaultOrientationPASBOrPTree(
  isMotor,
  isGearBox,
  isMotorMounted,
  isGearBoxMounted,
  mountingSide,
  productOrComponentType
) {
  // console.log("getDefaultOrientationPASBOrPTree", isMotor, isGearBox, isMotorMounted, isGearBoxMounted);
  let motorOrientation = "90";
  let gearBoxOrientation = "90";
  if (mountingSide?.toLowerCase() === RIGHT.toLowerCase()) {
    if (isMotor && isGearBox) {
      motorOrientation = productOrComponentType === "PLANETARY_GEARBOX" ? "90" : "180";
      gearBoxOrientation = productOrComponentType === "PLANETARY_GEARBOX" ? "90" : "0";
    }

    if (!isMotor && isGearBox) {
      motorOrientation = NO_MOTOR;
      gearBoxOrientation = productOrComponentType === "PLANETARY_GEARBOX" ? "90" : "0";
    }
  }

  if (mountingSide?.toLowerCase() === LEFT.toLowerCase()) {
    if (isMotor && isGearBox) {
      motorOrientation = productOrComponentType === "PLANETARY_GEARBOX" ? "90" : "0";
      gearBoxOrientation = productOrComponentType === "PLANETARY_GEARBOX" ? "90" : "180";
    }

    if (!isMotor && isGearBox) {
      motorOrientation = NO_MOTOR;
      gearBoxOrientation = productOrComponentType === "PLANETARY_GEARBOX" ? "90" : "180";
    }
  }

  motorOrientation = isMotorMounted && isMotor ? motorOrientation : NO_MOTOR;
  gearBoxOrientation = isGearBoxMounted && isGearBox ? gearBoxOrientation : NO_GEARBOX;

  return [motorOrientation, gearBoxOrientation];
}

export function getDefaultOrientationPASSTree(isMotor, isGearBox, isMotorMounted, isGearBoxMounted) {
  // console.log("getDefaultOrientationPASSTree", isMotor, isGearBox, isMotorMounted, isGearBoxMounted);
  const motorOrientation = isMotorMounted && isMotor ? "90" : NO_MOTOR;
  const gearBoxOrientation = isGearBoxMounted && isGearBox ? "90" : NO_GEARBOX;

  return [motorOrientation, gearBoxOrientation];
}

export function getMotorGearBoxDefaultOrientation(
  productCode,
  isMotor,
  isGearBox,
  isMotorMounted,
  isGearBoxMounted,
  mountingSide,
  productOrComponentType
) {
  // console.log(
  //   "getMotorGearBoxDefaultOrientation",
  //   productCode,
  //   isMotor,
  //   isGearBox,
  //   isMotorMounted,
  //   isGearBoxMounted,
  //   mountingSide,
  //   productOrComponentType
  // );
  if (PAS4H.test(productCode) || PAS4A.test(productCode)) {
    return [NO_MOTOR, NO_GEARBOX];
  }

  if (
    PAS4B.test(productCode) ||
    PAS4P.test(productCode) ||
    PAD42B.test(productCode) ||
    PAD42P.test(productCode) ||
    PAD42E.test(productCode)
  ) {
    return getDefaultOrientationPASBOrPTree(
      isMotor,
      isGearBox,
      isMotorMounted,
      isGearBoxMounted,
      mountingSide,
      productOrComponentType
    );
  }

  if (PAS4S.test(productCode)) {
    return getDefaultOrientationPASSTree(isMotor, isGearBox, isMotorMounted, isGearBoxMounted);
  }

  return ["90", "90"];
}

export function getGearBoxOrientation() {
  // console.log("getGearBoxOrientation");
  const selectedAxis = useSelector(selectSelectedAxis);
  const productCode = selectedAxis?.axis?.axisGCR;
  if (PAS4H.test(productCode) || PAS4A.test(productCode)) {
    return [NO_GEARBOX];
  }
  return ["0", "90", "180", "270", NO_GEARBOX];
}
